import { Url } from './url';

export enum MediaType {
  STATIC = 'STATIC',
  SLIDE = 'SLIDE',
  VIDEO = 'VIDEO',
  ITEM = 'ITEM',
}

export enum MediaSurface {
  COMPANION = 'COMPANION',
  SHOP = 'SHOP',
}

/** Join row from `media_item` (menu item reference + slide order). */
export interface MediaItemRef {
  mediaId: string;
  menuItemId: string;
  position: number;
  translations: MediaItemTranslation[];
}

/** Join row from `media_url` with nested `url` row. */
export interface MediaUrlRef {
  mediaId: string;
  url: Url;
}

export interface Media {
  id: string;
  type: MediaType;
  surface: MediaSurface;
  items: MediaItemRef[];
  urls: MediaUrlRef[];
  translations: MediaTranslation[];
  advanceTime: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MediaTranslation {
  mediaId: string;
  languageCode: string;
  title: string | null;
  subtitle: string | null;
  label: string | null;
}

export interface MediaItemTranslation {
  mediaId: string;
  itemId: string;
  languageCode: string;
  label: string | null;
}
